import * as stylex from "@stylexjs/stylex";
import {
  spacing,
  colors,
  fonts,
  fontSizes,
} from "@softmax/design-system/tokens.stylex";

export const styles = stylex.create({
  eyebrow: {
    margin: 0,
    color: colors.muted,
    fontSize: fontSizes.caption,
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    overflowWrap: "anywhere",
  },
  smallMuted: {
    margin: 0,
    color: colors.muted,
    fontSize: fontSizes.caption,
    lineHeight: 1.6,
  },
  bodyText: { margin: 0, fontSize: fontSizes.reading, lineHeight: 1.6 },
  byline: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "baseline",
    gap: spacing.space6,
    color: colors.muted,
    fontSize: fontSizes.caption,
    lineHeight: 1.6,
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: spacing.space16,
    marginTop: spacing.space8,
  },
  label: {
    display: "flex",
    flexDirection: "column",
    gap: spacing.space6,
  },
  fieldTitle: {
    fontSize: fontSizes.caption,
    fontWeight: 600,
    color: colors.subtle,
    letterSpacing: "0.04em",
    textTransform: "uppercase",
  },
  actions: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: spacing.space8,
  },
  section: {
    display: "flex",
    flexDirection: "column",
    gap: spacing.space12,
    marginTop: spacing.space24,
  },
  sectionTitle: {
    margin: 0,
    fontFamily: fonts.mono,
    fontSize: fontSizes.title,
    fontWeight: 600,
    lineHeight: 1.2,
    letterSpacing: "-0.4px",
  },
});
